import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  Shield,
  CheckCircle,
  XCircle,
  User,
  Mail,
  Building,
  Ticket,
} from "lucide-react";
import { qrAPI } from "../services/api";
import "./VerifyAttendee.css";

const VerifyAttendee = () => {
  const { registrationId } = useParams();
  const [attendee, setAttendee] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAttendee = async () => {
      try {
        const response = await qrAPI.verify(registrationId);
        setAttendee(response.data);
      } catch (err) {
        console.error("Verification failed:", err);
        setError("Invalid or expired QR code.");
      } finally {
        setLoading(false);
      }
    };

    if (registrationId) {
      fetchAttendee();
    }
  }, [registrationId]);

  if (loading) {
    return (
      <div className="verify-page">
        <div className="verify-container skeleton-container">
          <div className="skeleton-avatar" />
          <div className="skeleton-text" />
          <div className="skeleton-text short" />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="verify-page">
        <div className="verify-container error">
          <XCircle size={48} color="#ef4444" />
          <h2>Verification Failed</h2>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="verify-page">
      <div className="verify-container">
        <div className="verify-header">
          <Shield size={24} className="shield-icon" />
          <span>Official RF Conference Pass</span>
        </div>

        <div className="verify-status">
          <CheckCircle size={32} color="#10b981" />
          <span>Verified Attendee</span>
        </div>

        <div className="attendee-card">
          {attendee.avatar_url ? (
            <img
              src={attendee.avatar_url}
              alt={attendee.full_name}
              className="attendee-photo"
            />
          ) : (
            <div className="attendee-placeholder">
              <User size={40} />
            </div>
          )}

          <h1>{attendee.full_name}</h1>
          <div className="attendee-badge">{attendee.pass_type}</div>

          <div className="attendee-details">
            <div className="detail-item">
              <Ticket size={16} />
              <span>{attendee.registration_id}</span>
            </div>
            <div className="detail-item">
              <Mail size={16} />
              <span>{attendee.email}</span>
            </div>
            {attendee.organization && (
              <div className="detail-item">
                <Building size={16} />
                <span>{attendee.organization}</span>
              </div>
            )}
          </div>
        </div>

        <div className="verify-footer">
          <p>Scanned at {new Date().toLocaleTimeString()}</p>
        </div>
      </div>
    </div>
  );
};

export default VerifyAttendee;
